export enum SampleShiftCoverage {
    PartialShift = 0,
    FullShift = 1
}